<template>
  <div>
    <el-dialog
      title="统计/分润"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
      @close="dialogVisibleClose"
    >
      <el-table :data="tableData" style="width: 100%">
        <el-table-column
          prop="name"
          label="时间"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="项目ID"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="项目"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="单价"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="数量"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column prop="name" label="分润估算" align="center">
          <el-table-column
            prop="name"
            label="理想业务规模"
            align="center"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="实际业务数"
            align="center"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="预估营收"
            align="center"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="待银行或保险对账收益"
            align="center"
          >
            <el-table-column
              prop="name"
              label="预付款"
              align="center"
              min-width="100"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="后付款"
              align="center"
              min-width="100"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="免费"
              align="center"
              min-width="100"
            >
            </el-table-column>
          </el-table-column>
        </el-table-column>
        <el-table-column
          prop="name"
          label="可分润金额"
          align="center"
          min-width="100"
        >
        </el-table-column>
      </el-table>
      <!-- <MyTable
        class="mytable"
        :tableData="tableData"
        :tableConfig="tableConfig"
      
        height="400px"
        :indexFlag="true"
      >
        <template v-slot:index="slotData">
          <span>
            {{ slotData.scope.$index + 1 }}
          </span>
        </template>
      </MyTable> -->
      <Pagination
        style="margin-top: 10px"
        :total="total"
        @getNewData="getPage"
        ref="pagination"
      />
    </el-dialog>
  </div>
</template>

<script>
import MyTable from "@/components/Table";

export default {
  components: {
    MyTable,
  },
  props: {
    visible: Boolean,
  },
  data() {
    return {
      tableData: [],
      loading: false,
      total: 0,
      tableConfig: [
        {
          field: "name",
          label: "时间",
          align: "center",
          flag: true,
          minWidth: 100,
        },
        {
          field: "name",
          label: "项目ID",
          align: "center",
          flag: true,
          minWidth: 100,
        },
        {
          field: "name",
          label: "项目",
          align: "center",
          flag: true,
          minWidth: 100,
        },
        {
          field: "name",
          label: "单价",
          align: "center",
          flag: true,
          minWidth: 100,
        },
        {
          field: "name",
          label: "数量",
          align: "center",
          flag: true,
          minWidth: 100,
        },
        {
          label: "分润估算",
          align: "center",
          flag: true,
          children: [
            {
              field: "name",
              label: "理想业务规模",
              align: "center",
              flag: true,
              minWidth: 100,
            },
            {
              field: "name",
              label: "实际业务数",
              align: "center",
              flag: true,
              minWidth: 100,
            },
            {
              field: "name",
              label: "预估营收",
              align: "center",
              flag: true,
              minWidth: 100,
            },
            {
              label: "待银行或保险对账收益",
              align: "center",
              flag: true,
              children: [
                {
                  field: "name",
                  label: "预付款",
                  align: "center",
                  flag: true,
                  minWidth: 100,
                },
                {
                  field: "name",
                  label: "后付款",
                  align: "center",
                  flag: true,
                  minWidth: 100,
                },
                {
                  field: "name",
                  label: "免费",
                  align: "center",
                  flag: true,
                  minWidth: 100,
                },
              ],
            },
          ],
        },
        {
          field: "name",
          label: "可分润金额",
          align: "center",
          flag: true,
          minWidth: 100,
        },
      ],
      tableHeight: "",
      dialogVisible: false,
    };
  },
  created() {},
  methods: {
    getPage() {},
    dialogVisibleClose() {
      this.$emit("close");
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
    },
  },
};
</script>

<style lang="less">
</style>
